import { Map } from "immutable";

import { validateString } from "seneca-common/utils/functions/validation/validateString";
import {
  makeMaxStringLengthValidator,
  makeMinStringLengthValidator
} from "seneca-common/utils/functions/validationFunctions";

const MIN_FEEDBACK_LENGTH = 20;
const MAX_FEEDBACK_LENGTH = 1000;

const validateFeedbackHasEnoughCharacters =
  makeMinStringLengthValidator(MIN_FEEDBACK_LENGTH);
const validateFeedbackHasTooManyCharacters =
  makeMaxStringLengthValidator(MAX_FEEDBACK_LENGTH);

export function validateFeedback(formValues: Map<string, string>) {
  const { feedbackType, feedback } = formValues.toJS() as any;

  function validateFeedbackType(feedbackType: string) {
    if (validateString(feedbackType)) {
      return "Please pick an option";
    }
  }

  function validateFeedback(feedback: string) {
    if (validateFeedbackHasEnoughCharacters(feedback)) {
      return "Please give us your feedback in a little more detail!";
    }

    if (validateFeedbackHasTooManyCharacters(feedback)) {
      return `Your feedback must not exceed ${MAX_FEEDBACK_LENGTH} characters.`;
    }
  }

  return {
    feedbackType: validateFeedbackType(feedbackType),
    feedback: validateFeedback(feedback)
  };
}
